import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useFetch = (jsonPath) => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${jsonPath}`);    
        // Check if the response is OK (status in the range 200-299)
        if (!response.ok) {
          // If response status is not OK, redirect to the main page
          console.log(`Failed to fetch JSON: ${response.status} ${response.statusText}`);
          // navigate("/");
          return;
        }
        
        const jsonData = await response.json();
        setData(jsonData);
      } catch (error) {
        console.log(error, "Error Fetching Data");
        // If there's any error (including network errors), redirect to main page
        // navigate("/");
      }
    };

    fetchData();
  }, [jsonPath, navigate]);

  return data;
};

export default useFetch;